export const SET_CATEGORY_ID: "SET_CATEGORY_ID" = "SET_CATEGORY_ID";
export const SET_SEARCH_VALUE: "SET_SEARCH_VALUE" = "SET_SEARCH_VALUE";
export const SET_SORT: "SET_SORT" = "SET_SORT";
export const SET_FILTERS: "SET_FILTERS" = "SET_FILTERS";
